// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1uihoxq0 {
  background-color: white;
}
._1uihoxq1 {
  order: 1;
}
._1uihoxq2 {
  display: flex;
  align-items: center;
  justify-items: center;
  width: var(--_18w76bwn);
  height: var(--_18w76bwm);
  position: relative;
  text-align: center;
  border-radius: var(--_18w76bw4t);
  background-color: var(--_18w76bw2g);
}
._1uihoxq2::after {
  content: "";
  z-index: 1;
  position: absolute;
  top: 100%;
  left: calc(50% - 4px);
  width: 0;
  height: 0;
  border-top: solid 4px var(--_18w76bw2g);
  border-left: solid 4px transparent;
  border-right: solid 4px transparent;
}
._1uihoxq3 {
  background-color: var(--_18w76bw33);
}
._1uihoxq3::after {
  border-top: solid 4px var(--_18w76bw33);
}
._1uihoxq4:hover {
  color: var(--_18w76bw2f);
  text-decoration: underline;
}
@media screen and (min-width: 768px) {
  ._1uihoxq0 {
    padding: var(--_18w76bwh);
    flex-wrap: wrap;
  }
  ._1uihoxq1 {
    min-width: 280px;
    order: initial;
  }
}
@media screen and (min-width: 1024px) {
  ._1uihoxq0 {
    padding: var(--_18w76bwh) var(--_18w76bwn);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE;IACE,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,0CAA0C;EAC5C;AACF","sourcesContent":["._1uihoxq0 {\n  background-color: white;\n}\n._1uihoxq1 {\n  order: 1;\n}\n._1uihoxq2 {\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  width: var(--_18w76bwn);\n  height: var(--_18w76bwm);\n  position: relative;\n  text-align: center;\n  border-radius: var(--_18w76bw4t);\n  background-color: var(--_18w76bw2g);\n}\n._1uihoxq2::after {\n  content: \"\";\n  z-index: 1;\n  position: absolute;\n  top: 100%;\n  left: calc(50% - 4px);\n  width: 0;\n  height: 0;\n  border-top: solid 4px var(--_18w76bw2g);\n  border-left: solid 4px transparent;\n  border-right: solid 4px transparent;\n}\n._1uihoxq3 {\n  background-color: var(--_18w76bw33);\n}\n._1uihoxq3::after {\n  border-top: solid 4px var(--_18w76bw33);\n}\n._1uihoxq4:hover {\n  color: var(--_18w76bw2f);\n  text-decoration: underline;\n}\n@media screen and (min-width: 768px) {\n  ._1uihoxq0 {\n    padding: var(--_18w76bwh);\n    flex-wrap: wrap;\n  }\n  ._1uihoxq1 {\n    min-width: 280px;\n    order: initial;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1uihoxq0 {\n    padding: var(--_18w76bwh) var(--_18w76bwn);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
